@if (auth.currentUserIDSig()?.uid !== null) {
<nav class="navbar navbar-theme-dark-blue text-center sticky-top" *transloco="let t">
    <!-- <nav class="navbar bgc-white navbar-light text-center shadow-sm sticky-top" *transloco="let t"> -->
    <div class="container-fluid"
        [ngClass]="{'menuMax' : sb.currentSidebarSize() === 'max','menuMin' : sb.currentSidebarSize() === 'min'}">
        <div class="mt-2 d-lg-none">
            <a href="#" class="material-symbols-outlined menubarIcon d-lg-none bouncing" role="button"
                data-bs-toggle="modal" data-bs-target="#mobileMenuModal" title="{{t('menu.selection-menu')}}">
                menu
            </a>
        </div>
        <a href="#" class="material-symbols-outlined menubarIcon disabled d-none d-lg-block">

        </a>
        <object data="./../../assets/savologic-symbol.svg" class="bouncing brandIcon d-md-none"></object>
        <object data="./../../assets/savologic-artnox-light-logo.svg"
            class="bouncing brandIcon d-none d-md-block"></object>
        <!-- <object data="./../../assets/savologic-logo.svg" class="bouncing brandIcon d-none d-md-block"></object> -->
        <div class="initials d-flex rounded-circle" [ngClass]="{'itsDev': !environment.production}" routerLink="/user">

            @if (!this.db.currentUserDataSig()?.name) {
            <p class="placeholder-glow mb-0">
                <span class="placeholder col-6 bg-info"></span>
            </p>
            }
            @if (this.db.currentUserDataSig()?.name) {
            <span class="m-auto" title="{{t('menu.selection-profile-new')}}">{{this.db.currentUserDataSig()?.name |
                slice:0:1}}{{this.db.currentUserDataSig()?.surname | slice:0:1}}</span>
            }
        </div>
    </div>
</nav>
}

@if (auth.currentUserIDSig()?.uid === null) {

<nav class="navbar bgc-white navbar-light text-center shadow-sm sticky-top">
    <div class="container-fluid">
        <a href="#" class="material-symbols-outlined menubarIcon" alt="asd">
            home
        </a>
        <img src="./../../assets/savologic-logo.svg" class="branding brandIcon">
        <div *transloco="let t; prefix: 'lang'">
            <div class="dropdown dropstart">
                <span class="material-symbols-outlined menubarIcon mt-1" type="button" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    language
                </span>
                <ul class="dropdown-menu">
                    <li *ngFor="let language of languages">
                        <button class="dropdown-item" type="button" value="{{language}}"
                            (click)="onChange($event)">{{t(language)}}</button>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</nav>
}




<div class="modal fade" id="mobileMenuModal" tabindex="-1" aria-labelledby="mobileMenuModalLabel" aria-hidden="true"
    *transloco="let t">
    <div class="modal-dialog m-0 mobile-sidebar">
        <div class="modal-content">
            <div class="mobile-sidebar">
                <div>
                    <div class="text-center mx-2 mt-2">
                        <object data="./../../assets/savologic-artnox-light-logo.svg"
                            class="bouncing brandIcon"></object>
                    </div>

                    @if (!this.auth.currentLangSig()?.lang) {
                    <div class="row my-5">
                        <div class="col text-center">
                            <div class="svl-ripple">
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                    }
                    @if (this.auth.currentLangSig()?.lang) {
                    <div class="sidebar-item row align-items-center" routerLink="/input"
                        routerLinkActive="sidebar-item-active" title="{{t('menu.selection-input-new-long')}}">
                        <div class="d-flex">
                            <div class="sidebar-item-icon-box">
                                <span class="material-symbols-outlined icon-size">add_circle</span>
                            </div>
                            <div class="sidebar-item-description-box">
                                {{t('menu.selection-input-new-long')}}
                            </div>
                        </div>
                    </div>
                    <div class="sidebar-item row align-items-center" routerLink="/dashboard"
                        routerLinkActive="sidebar-item-active" title="{{t('menu.selection-dashboard')}}">
                        <div class="icon-link">
                            <div class="sidebar-item-icon-box text-center">
                                <span
                                    class="material-symbols-outlined icon-size align-items-center">planner_review</span>
                            </div>
                            <div class="sidebar-item-description-box">
                                {{t('menu.selection-dashboard')}}
                            </div>
                        </div>
                    </div>
                    <div class="sidebar-item row align-items-center" routerLink="/categories"
                        routerLinkActive="sidebar-item-active" title="{{t('menu.selection-categories')}}">
                        <div class="icon-link">
                            <div class="sidebar-item-icon-box text-center">
                                <span class="material-symbols-outlined icon-size align-items-center">view_column</span>
                            </div>
                            <div class="sidebar-item-description-box">
                                {{t('menu.selection-categories')}}
                            </div>
                        </div>
                    </div>
                    <div class="sidebar-item row align-items-center" routerLink="/transactions"
                        routerLinkActive="sidebar-item-active" title="{{t('menu.selection-transactions')}}">
                        <div class="icon-link">
                            <div class="sidebar-item-icon-box text-center">
                                <span class="material-symbols-outlined icon-size align-items-center">receipt_long</span>
                            </div>
                            <div class="sidebar-item-description-box">
                                {{t('menu.selection-transactions')}}
                            </div>
                        </div>
                    </div>
                    <div class="sidebar-item row align-items-center" routerLink="/budget"
                        routerLinkActive="sidebar-item-active" title="{{t('menu.selection-budget')}}">
                        <div class="icon-link">
                            <div class="sidebar-item-icon-box text-center">
                                <span class="material-symbols-outlined icon-size align-items-center">savings</span>
                            </div>
                            <div class="sidebar-item-description-box">
                                {{t('menu.selection-budget')}}
                            </div>
                        </div>
                    </div>
                    }


                </div>
                <!-- <div class="bottom-item"> -->
                <div class="mobile-sidebar-bottom-section">
                    <div class="sidebar-item row align-items-center" title="{{t('menu.selection-contact')}}"
                        data-bs-toggle="modal" data-bs-target="#contactModal">
                        <div class="icon-link">
                            <div class="sidebar-item-icon-box text-center">
                                <span class="material-symbols-outlined icon-size align-items-center">mail</span>
                            </div>
                            <div class="sidebar-item-description-box">
                                {{t('menu.selection-contact')}}
                            </div>
                        </div>
                    </div>

                    <div class="sidebar-item row align-items-center" title="{{t('menu.selection-signout')}}"
                        data-bs-toggle="modal" data-bs-target="#signOutModal">
                        <div class="icon-link">
                            <div class="sidebar-item-icon-box text-center">
                                <span class="material-symbols-outlined icon-size align-items-center">logout</span>
                            </div>
                            <div class="sidebar-item-description-box">
                                {{t('menu.selection-signout')}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- SIGNOUT MODAL -->

<div class="modal fade" id="signOutModal" tabindex="-1" aria-labelledby="signOutModalLabel" aria-hidden="true"
    *transloco="let t">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row">
                    <div class="col text-end">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            title="{{t('general.button-close')}}"></button>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <span class="material-symbols-outlined modal-icon-grey align-content-center">
                            logout
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <div class="row mt-2">
                            <div class="col">
                                <h4>{{t('menu.signout-header')}}</h4>
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col">
                                <i>{{t('menu.signout-description')}}</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer px-0">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-4 d-grid">
                            <button class="btn btn-sm btn-link btn-link-secondary" type="button" data-bs-dismiss="modal"
                                title="{{t('general.button-cancel')}}">
                                {{t('general.button-cancel')}}</button>
                        </div>
                        <div class="col-8 d-grid">
                            <button data-bs-dismiss="modal" class="btn btn-sm btn-secondary rounded-pill" type="button"
                                (click)="this.LogoutCheck()" routerLink="/user"
                                title="{{t('menu.selection-signout')}}">{{t('menu.selection-signout')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- CONTACT MODAL -->
<div class="modal fade" id="contactModal" tabindex="-1" aria-labelledby="contactModalLabel" aria-hidden="true"
    *transloco="let t">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row">
                    <div class="col text-end">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            title="{{t('general.button-close')}}"></button>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <span class="material-symbols-outlined modal-icon-grey align-content-center">
                            mail
                        </span>
                    </div>
                </div>
                <div class="row super-font">
                    <div class="col text-center">
                        <div class="row mt-2">
                            <div class="col">
                                <span>{{t('menu.contact-header')}}</span>
                            </div>
                        </div>
                        <div class="row m-3">
                            <div class="col">
                                <h4><strong>help&#64;savologic.com</strong></h4>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col">
                                <i>{{t('menu.contact-info')}}</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer px-0">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-4 d-grid">
                            <button class="btn btn-sm btn-link btn-link-secondary" type="button" data-bs-dismiss="modal"
                                title="{{t('general.button-cancel')}}">
                                {{t('general.button-cancel')}}</button>
                        </div>
                        <div class="col-8 d-grid">
                            <button data-bs-dismiss="modal" class="btn btn-sm btn-secondary rounded-pill" type="button"
                                title="{{t('general.button-close')}}">{{t('general.button-close')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>